import React, { Component } from 'react';
import {AdminNotice} from "@adrianoferreira/wp-react-admin";

export const Notices = (props) => {
	return(
		<React.Fragment>
			{props.requiredEmptyFields.map(el => <AdminNotice key={el.label} type="error" disappear={false} message={el.label + ' is required'}/>)}
			{props.saved && props.routeId ? <AdminNotice disappear={true} message="Saved Successfully"/> : ''}
			{props.invalidRoute ? <AdminNotice type="error" disappear={false} message="Route already exists!"/> : ''}
		</React.Fragment>
	);
};
